import { Http } from '@/lib/http';

export class OnBoarderAccountsService extends Http {
  constructor() {
    super();
    this.endpoint = 'onboarder/app/';
  }

  /**
   * Gets an account by the given id
   * @param {string} id Account id
   */
  getAccountByLoanIdAccountNumber(id) {
    return this.httpClient().get(`${this.endpoint}accounts/${id}`);
  }

  /**
   * Get all accounts based on the given query object
   * @param {object} query Query object
   */
  getAccounts(query = {}) {
    return this.httpClient().get(`${this.endpoint}accounts/?`, {
      params: query
    });
  }

  getAccountByPerson(query = {}) {
    return this.httpClient().get(`${this.endpoint}accounts/findAccountByPerson`, {
      params: query
    })
  }

  /**
   * Get all persons based on the given query object
   * @param {object} query Query object
   */
  getPersonAccount(query = {}) {
    return this.httpClient().post(`${this.endpoint}persons/find`, query);
  }
  /**
   * Get a single person by the given id
   * @param {string} id Person id
   */
  getPersonById(id) {
    return this.httpClient().get(`${this.endpoint}persons/${id}`);
  }

  /**
   * Update an account by the given id
   * @param {string} id Account id
   * @param {object} data Account data to update
   */
  updateAccount(id, data) {
    return this.httpClient().patch(`${this.endpoint}accounts/${id}`, data);
  }

  createAccount(data) {
    return this.httpClient().post(`${this.endpoint}accounts`, data)
  }

  /**
   * Update a person by the given id
   * @param {string} id Person id
   * @param {object} data Person data to update
   */
  updatePerson(id, data) {
    return this.httpClient().patch(`${this.endpoint}persons/${id}`, data);
  }

  createPerson(data) {
    return this.httpClient().post(`${this.endpoint}persons/`, data)
  }
  /**
   * Uploads a document for the person with the given id
   * @param {string} id Person id
   * @param {object} Formdata containing the document along with other data
   */
  createPersonDocument(id, data) {
    return this.httpClient().post(
      `${this.endpoint}persons/${id}/document`,
      data
    );
  }

  /**
   * Removes a document for the person with the given id
   * @param {string} personId Person id
   * @param {string} documentName Document name
   */
  removePersonDocument(personId, documentName) {
    return this.httpClient().delete(
      `${this.endpoint}persons/${personId}/document/${documentName}`
    );
  }
}
